var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e01b41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c51335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e4b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#053677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.666667,
    cy: 2.666667,
    fill: "#fff",
    fillRule: "evenodd",
    r: 2.666667
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5.333333 3.047619)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.666667,
    cy: 2.666667,
    fill: "url(#c)",
    r: 2.666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.04761905c.76190474.7142857 1.9047619 1.14285713 2.66666667 0 .76190476-1.14285715 2.28571428-1.14285718 2.66666666 0 .38095238 1.14285713 0 2.28571428 0 2.28571428h-5.33333333s-.76190474-2.99999998 0-2.28571428z",
    fill: "url(#d)",
    mask: "url(#g)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m10.8251552 2.98855041c-.0538143-.09320905-.0268261-.20953849.0690633-.26490029l.3268235-.18869164c.0919569-.05309133.2099085-.02094931.2639421.07263955l.9479784 1.6419468c.0538143.09320905.0268261.20953849-.0690634.26490029l-.3268234.18869163c-.0919569.05309134-.2099085.02094931-.2639421-.07263954zm.9897433-.57142857c-.0538142-.09320906-.0268261-.2095385.0690633-.26490029l.3268236-.18869164c.0919568-.05309133.2099084-.02094931.263942.07263955l.9479784 1.6419468c.0538143.09320905.0268261.20953849-.0690633.26490029l-.3268235.18869163c-.0919569.05309134-.2099085.02094931-.263942-.07263954zm-9.23760431 5.33333332c-.05381427-.09320906-.02682611-.20953848.06906333-.26490028l.32682351-.18869163c.09195689-.05309134.20990849-.02094931.26394204.07263954l.94797843 1.64194681c.05381427.09320907.02682611.20953851-.06906333.26490027l-.3268235.18869165c-.0919569.05309136-.2099085.02094934-.26394205-.07263954zm.98974332-.57142856c-.05381427-.09320905-.0268261-.20953849.06906333-.26490029l.3268235-.18869164c.0919569-.05309133.2099085-.02094931.26394205.07263955l.94797843 1.64194681c.05381427.09320907.02682611.20953851-.06906333.26490027l-.32682351.18869165c-.09195689.05309135-.20990849.02094934-.26394204-.07263954zm8.20609609-.38095238c.0538143-.09320905.1680526-.12800134.2639421-.07263955l.3268234.18869164c.091957.05309134.1230969.17131143.0690634.26490029l-.9479784 1.64194681c-.0538143.09320907-.1680527.12800129-.2639421.07263954l-.3268235-.18869165c-.0919569-.05309136-.1230969-.1713114-.0690633-.26490027zm.9897434.57142857c.0538142-.09320905.1680525-.12800134.263942-.07263954l.3268235.18869163c.0919569.05309134.1230969.17131141.0690633.26490028l-.9479784 1.64194682c-.0538143.09320907-.1680527.1280013-.263942.07263954l-.3268236-.18869165c-.0919568-.05309136-.1230969-.17131139-.0690633-.26490027zm-9.23760438-5.33333333c.05381428-.09320906.16805261-.12800135.26394205-.07263955l.3268235.18869164c.09195689.05309133.12309689.17131143.06906333.26490029l-.94797843 1.6419468c-.05381427.09320905-.1680526.12800134-.26394204.07263954l-.32682351-.18869163c-.0919569-.05309134-.12309688-.17131144-.06906333-.26490029zm.98974332.57142857c.05381427-.09320905.16805261-.12800134.26394204-.07263955l.32682351.18869164c.09195689.05309134.12309688.17131143.06906333.26490029l-.94797843 1.6419468c-.05381427.09320905-.16805261.12800134-.26394205.07263954l-.3268235-.18869163c-.09195689-.05309134-.12309688-.17131144-.06906333-.26490029z",
    fill: "url(#e)",
    fillRule: "nonzero",
    mask: "url(#f)",
    opacity: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/KR.ac909227b510b67bba4d770233d2f9a9.svg";
export { ForwardRef as ReactComponent };